(function() {
  'use strict';

  angular
    .module('admin.configurations.service', [])
    .factory('ConfigurationsService', ConfigurationsService);

  /** @ngInject */
  function ConfigurationsService($http, $q, API) {

    function list(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/configurations')
          .success(defered.resolve);

        return defered.promise;
    }

    function set(key, model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/configurations/' + key, model)
          .success(defered.resolve);

        return defered.promise;
    }

    return{
       list: list,
       set: set
    };

  }

})();
